export const breakpoints = [ '32em', '48em', '64em' ];
export const space = ["0.5em", "1em", "1.5em","2em", "3em", "4em", "6em"];
export const width = ["0.5em", "1em", "1.5em","2em", "3em", "4em", "6em"];
export const heights = ["0.5em", "1em", "1.5em","2em", "3em", "4em", "6em"];